var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChargement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#0350a5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M88.7,17.1L75,13.8c-0.3-0.1-0.7,0.1-0.8,0.5L59.4,71.2c-0.6,1.4-2.2,2.1-3.7,1.8L11.4,62.4c-0.4-0.1-0.7,0.1-0.8,0.5   c-0.1,0.4,0.1,0.7,0.5,0.8l44.4,10.6c0.4,0.1,0.7,0.1,1.1,0.1c1.8,0,3.4-1,4.2-2.7c0,0,0-0.1,0-0.1l14.7-56.4l13,3.1   c0.4,0.1,0.7-0.1,0.8-0.5C89.3,17.5,89.1,17.2,88.7,17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3,70c-0.4-0.1-0.9-0.2-1.3-0.2c-2.7,0-5,1.8-5.6,4.4c-0.7,3.1,1.2,6.2,4.3,6.9c0.4,0.1,0.9,0.2,1.3,0.2   c2.7,0,5-1.8,5.6-4.4c0.4-1.5,0.1-3-0.7-4.3C20.1,71.3,18.8,70.4,17.3,70z M20.3,76.6c-0.5,2-2.2,3.4-4.3,3.4c-0.3,0-0.7,0-1-0.1   c-2.4-0.6-3.8-3-3.3-5.3c0.5-2,2.2-3.4,4.3-3.4c0.3,0,0.7,0,1,0.1c1.1,0.3,2.1,1,2.7,2C20.4,74.3,20.6,75.5,20.3,76.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2,77.9c-0.4-0.1-0.9-0.2-1.3-0.2c-2.7,0-5,1.8-5.6,4.4c-0.7,3.1,1.2,6.2,4.3,6.9c0.4,0.1,0.9,0.2,1.3,0.2   c2.7,0,5-1.8,5.6-4.4c0.4-1.5,0.1-3-0.7-4.3C52.9,79.1,51.7,78.2,50.2,77.9z M53.1,84.5c-0.5,2-2.2,3.4-4.3,3.4c-0.3,0-0.7,0-1-0.1   c-2.4-0.6-3.8-3-3.3-5.3c0.5-2,2.2-3.4,4.3-3.4c0.3,0,0.7,0,1,0.1c1.1,0.3,2.1,1,2.7,2C53.2,82.2,53.4,83.3,53.1,84.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6,59.2L51.2,68c0.4,0.1,0.7,0.1,1.1,0.1c2.2,0,4.1-1.5,4.7-3.7l7.6-31.8c0.3-1.2,0.1-2.5-0.6-3.6   c-0.7-1.1-1.7-1.9-3-2.1l-36.6-8.8C24,18,23.7,18,23.3,18c-2.2,0-4.1,1.5-4.7,3.7L11,53.5C10.4,56,12,58.6,14.6,59.2z M12.3,53.8   l7.6-31.8c0.4-1.6,1.8-2.7,3.4-2.7c0.3,0,0.5,0,0.8,0.1l36.6,8.8c0.9,0.2,1.7,0.8,2.1,1.6c0.5,0.8,0.6,1.7,0.4,2.6l-7.6,31.8   c-0.4,1.6-1.8,2.7-3.4,2.7c-0.3,0-0.5,0-0.8-0.1l-36.6-8.8C13,57.5,11.9,55.6,12.3,53.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargement);
export default __webpack_public_path__ + "static/media/chargement.1e0e2eba4d8f09bf2f506fabfe3cb52b.svg";
export { ForwardRef as ReactComponent };